// import hooks
// import { useTranslation } from "react-i18next";

// import components
import CardList1 from "../Main/CardList1";
import PastProductsList from "../Main/PastProductsList";
import RoutPath from "../RoutPath";
import { Container, Row, Col } from "react-bootstrap";
import CartItem from "./CartItem";
import DiscountCode from "./DiscountCode";
import CartSummary from "./CartSummary";

// import assets
import "../../assets/css/cart.css";

// import data
import cardListData from "../../utils/data/cardListData";
import { cartList, summary } from "../../utils/data/cartData";

const Cart = () => {
    cardListData[0].title = "منتجات متشابه";
    // console.log("fine")
    return (
        <section className="cart-section ocean-section">
            <Container>
                <RoutPath />
                <Row>
                    <Col lg={8} className="ocean-col align-top">
                        {cartList.map((i) => (
                            <CartItem item={i} key={i.id} />
                        ))}
                    </Col>
                    <Col lg={4} className="ocean-col align-top">
                        <DiscountCode />
                        <CartSummary summary={summary} cmplt_btn={true} />
                    </Col>
                </Row>
            </Container>

            <CardList1 list={cardListData[0]} />
            <PastProductsList className="sections-past-products" />
        </section>
    );
};

export default Cart;
